/**
 * File: defaultValues.js
 * Project: EDI
 * File Created: Thursday, 20th July 2023 1:53:12 pm
 * Author: Diana Díaz Raboso (diana.diaz@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Monday, 31st August 2026 12:10:05 pm
 * Modified By: Ricardo Fernández Cuesta
 * -----
 * Copyright (c) 2023 - 2023 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 *
 */

/*
IMPORTANTE: No editar este archivo en noname-base-frontend 
debido a que al copiar el modulo este lo reemplazara.
*/
// import {filterUrls} from "helpers/Utils";
import { menusByPermissions, isSuperUserMenus } from 'helpers/Utils';

export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-hidden';

// Variable de la paginación de tablas
export const defaultMaxSize = 15;

export const subHiddenBreakpoint = 700;
export const menuHiddenBreakpoint = 600;

export const localeOptions = [
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'ca', name: 'Catalan', direction: 'ltr' },
  { id: 'fr', name: 'Frances', direction: 'ltr' },
];

// Esta funcion se utiliza para obtener el idioma del navegador
const getBrowserLocale = () => {
  const browserLang = navigator.language.split('-')[0];
  const supportedLocales = ['es', 'en', 'ca', 'fr'];
  return supportedLocales.includes(browserLang) ? browserLang : 'es';
};

export const defaultLocale = getBrowserLocale();

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};
// Se añade por los componentes de ejemplo de gogo-react en Noname-Base.
export const buyUrl = 'https://1.envato.market/k4z0';
export const servicePath = 'https://api.coloredstrategies.com';

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const databaseSelected = ''; // 'cosbim';
export const loginRoot = '/user/login';
// Fuera de /app: la home salta al homescreen del usuario, y si allí también
// recibe 403 la app se recarga sin fin. /error no pide nada a la API.
export const permissionDenied = '/error';

export const searchPath = `${adminRoot}/pages/miscellaneous/search`;

export const themeColorStorageKey = 'light.cosbim';
export const isMultiColorActive = false;
export const defaultColor = 'light.cosbim';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = false;
export const colors = [
  /*
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
  */
  'bluenoname',
  'pinknoname',
  'greennoname',
  'orangenoname',
];
// Los tres tipos de carpeta. La lista con sus etiquetas, los archivadores y los
// campos del filtro vienen del backend, en `parameters_schema/form-options/`;
// aquí solo quedan los identificadores, que son parte del contrato de la API y
// los que el código compara para saber qué puede hacer cada tipo.
export const nodeTypeDocuware = 'docuware';
export const nodeTypeAutodesk = 'autodesk';
export const nodeTypeLink = 'link';
// Extensiones que el navegador pinta con su propio visor. Solo se consultan
// cuando DocuWare no dice el tipo de contenido del documento.
//
// SVG queda fuera a proposito: se abre como documento, no como imagen, y desde
// una URL blob heredaria el origen de EDI, asi que un SVG con script podria leer
// el token del localStorage. Se descarga como cualquier otro fichero.
export const viewableExtensions = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.bmp',
  '.webp',
];

export const adminMenus = [''];
export const customFilter = '';
export const actualRedirect = '/home';
// TODO METER EL CUSTOMFILTER EN EL DEFAULT VALUES DE NONAME-BASE-FRONTEND

const useSuperUserMenus = process.env.REACT_APP_USE_SUPERUSER === 'true';

export const menuFunction = useSuperUserMenus
  ? isSuperUserMenus
  : menusByPermissions;
